import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { preventDefault, stopPropagation } from '../../../../utils/events'

export function useAITextGenerationDraftGuard({
  notificationId,
  notifications,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const isAIDraftActiveRef = useRef(false)

  function handleAIModeChange(isDraftMode) {
    isAIDraftActiveRef.current = isDraftMode

    if (!isDraftMode) {
      onRemoveNotification(notificationId)
    }
  }

  function ensureDraftApplied(event) {
    if (!isAIDraftActiveRef.current) {
      return true
    }

    if (event) {
      preventDefault(event)
      stopPropagation(event)
    }

    onSetNotification({
      id: notificationId,
      text: t('AITextGeneration.DraftNotAppliedErrorKey'),
      type: NOTIFICATION_TYPE.error,
    })

    return false
  }

  const isAIError = Boolean(
    notifications?.find(notification => notification.id === notificationId)
  )

  return { ensureDraftApplied, handleAIModeChange, isAIError }
}
